import {Card, Divider, Row, Tag, Typography} from "antd";
import { styled } from "styled-components";

export const StyledCard = styled(Card)`
    border-radius: 8px!important;
    .ant-card-body{
        padding: 15px 10px;
    }
`;

